import { useMemo, useState } from 'react'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  SAVE_ASSOCIATIONS: 'Associando entregas ao caminhão',
}

const INITIAL_CUSTOMER = {
  id: 0,
  nomeFantasia: '',
  latitude: 0,
  longitude: 0,
  deliveries: [
    {
      identifier: '',
      qte_sku: 0,
      weight: 0.0,
      client_id: 0,
      selected: false,
    },
  ],
}

const INITIAL_STATE = {
  show: false,
  customer: { ...INITIAL_CUSTOMER },
  deliveriesToAssociate: [],
  selecionarTodos: false,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
  pesoTotal: 0,
  pesoSelecionado: 0,
}

export default function useModalAssocCarga() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      //Events
      onInit(show, customer) {
        setState(prevState => ({
          ...prevState,
          show: show,
          customer: customer,
          selecionarTodos: customer.deliveries.every(delivery => delivery.selected),
          pesoTotal: customer.deliveries.reduce((total, delivery) => total + delivery.weight, 0),
          pesoSelecionado: 0,
        }))
      },

      onItemClicked(deliveryChecked, loadCounter, updateLoadCounter) {
        setState(prevState => {
          prevState.customer.deliveries.forEach((delivery, index) => {
            if (delivery.identifier === deliveryChecked.identifier) {
              if (!deliveryChecked.selected) {
                delivery.selected = true
                delivery.load_order = loadCounter
                updateLoadCounter('inc')
              } else {
                delivery.selected = false
                delivery.load_order = null
                updateLoadCounter('dec')
              }
            }
          })
          prevState.pesoSelecionado = prevState.customer.deliveries
            .filter(d => d.selected)
            .reduce((total, delivery) => total + delivery.weight, 0)
          return { ...prevState }
        })
      },

      onBtnSalvarClicked() {
        setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.SAVE_ASSOCIATIONS }))
      },

      onSelectedAllClick(loadCounter, updateLoadCounter) {
        setState(prevState => {
          prevState.selecionarTodos = !prevState.selecionarTodos
          prevState.customer.deliveries.forEach((delivery, index) => {
            if (prevState.selecionarTodos) {
              delivery.selected = prevState.selecionarTodos
              delivery.load_order = loadCounter + index
              updateLoadCounter('inc')
            } else {
              delivery.selected = prevState.selecionarTodos
              delivery.load_order = null
              updateLoadCounter('dec')
            }
          })
          prevState.pesoSelecionado = prevState.customer.deliveries
            .filter(d => d.selected)
            .reduce((total, delivery) => total + delivery.weight, 0)
          return { ...prevState }
        })
      },
    }
  }, [])

  return { state, localDispatch }
}
